import {
  IconFile,
  IconLayoutSidebar,
  IconMail,
  IconPencil,
  IconPlus,
  IconSearch,
  IconTimeline,
} from '@tabler/icons-react'

import { ObjectTypeMetadata } from 'src/lib/objects'

export const assistantToolOptions = {
  // DONE
  RESPOND_TO_USER: 'respond_to_user',
  OPEN_OBJECT: 'put_object_in_focus',
  CREATE_EMAIL_DRAFT: 'create_email_draft',
  CREATE_PAGE: 'create_page',

  // IN PROGRESS
  UPDATE_OBJECT: 'update_object',

  // TODO
  SEARCH_OBJECTS: 'search_objects',
  CREATE_OBJECT: 'create_object',
  OBJECT_HISTORY: 'object_history',
  SEARCH_MEETING_TRANSCRIPTS: 'search_meeting_transcripts',
  SEARCH_WEB: 'search_web',
  ADD_TO_CONTEXT: 'add_to_context',
  REMOVE_FROM_CONTEXT: 'remove_from_context',
  RESEARCH_PERSON: 'research_person',
}

export const assistantToolUiMetadata = {
  [assistantToolOptions.OPEN_OBJECT]: {
    label: 'Open in Sidebar',
    icon: IconLayoutSidebar,
    getDescription: (toolInput: any) => {
      return `Opened ${ObjectTypeMetadata[toolInput.objectType].label} "${toolInput.objectId}" in the sidebar`
    },
  },
  [assistantToolOptions.UPDATE_OBJECT]: {
    label: 'Update Object',
    icon: IconPencil,
    getDescription: (toolInput: any) => {
      const fallback = `Updating ${ObjectTypeMetadata[toolInput.objectType].label} "${toolInput.objectId}" ...`
      return toolInput.updateDescription || fallback
    },
  },
  [assistantToolOptions.CREATE_OBJECT]: {
    label: 'Create CRM Record',
    icon: IconPlus,
    getDescription: (toolInput: any) => {
      return `Creating ${ObjectTypeMetadata[toolInput.objectType].label} ...`
    },
  },
  [assistantToolOptions.SEARCH_OBJECTS]: {
    label: 'Search CRM',
    icon: IconSearch,
    getDescription: (toolInput: any) => {
      return `Searching for ${ObjectTypeMetadata[toolInput.objectType].pluralLabel} with "${toolInput.searchQuery}" ...`
    },
  },
  [assistantToolOptions.OBJECT_HISTORY]: {
    label: 'Timeline & History',
    icon: IconTimeline,
    getDescription: (toolInput: any) => {
      return `Viewing timeline & history for ${ObjectTypeMetadata[toolInput.objectType].label} "${toolInput.objectId}" ...`
    },
  },
  [assistantToolOptions.CREATE_EMAIL_DRAFT]: {
    label: 'Create Email Draft',
    icon: IconMail,
    getDescription: (toolInput: any) => {
      return `Creating email draft to ${toolInput.to.join(', ')} ...`
    },
  },
  [assistantToolOptions.CREATE_PAGE]: {
    label: 'Create Page',
    icon: IconFile,
    getDescription: (toolInput: any) => {
      return `Creating page with prompt "${toolInput.prompt}" ...`
    },
  },
}
